import { ErrorHandler, inject, Injectable } from '@angular/core';
import { NewRelicService } from './newrelic.service';

@Injectable()
export class NewRelicErrorHandlerService implements ErrorHandler {
  private readonly _newRelic = inject(NewRelicService);

  handleError(error: unknown): void {
    const err = error instanceof Error ? error : new Error(String(error));
    console.error('[NewRelicErrorHandler]', err);
    this._newRelic.noticeError(err);
  }
}
